import { store } from 'store';

import { authorizationHeader } from './loginService';
import {
  endLoginServiceSessionWith,
  isLoginServiceState,
  loginServiceToken,
  renewIfStale
} from './loginServiceSession';

/**
 * The staff member's login-service session, for code outside the RTK Query layer (LMD-683).
 *
 * The request layer cannot import the store, so it uses `loginServiceSession` directly; these bind
 * the same operations to the real store.
 */

/** Whether the login service is installed and holds the current session. */
export const isLoginServiceSession = (): boolean => isLoginServiceState(store.getState());

/** The current platform token from the SDK, renewed near expiry; null when there is none. */
export const getLoginServiceToken = (): Promise<null | string> => loginServiceToken();

/** The `Authorization` value for a platform token, in the SDK's format for the session's source. */
export const loginServiceAuthorization = (token: string): string =>
  authorizationHeader(token, store.getState().user.authSource);

/** A token newer than the refused one, renewing if needed; null when nothing newer comes back. */
export const renewLoginServiceToken = (refused: null | string): Promise<null | string> =>
  renewIfStale(refused);

/** Signs out at the login service (errors ignored), then clears the user. */
export const endLoginServiceSession = (): Promise<void> =>
  endLoginServiceSessionWith(store.dispatch);
